<div>
  <ng-container *ngIf="SIMPublicationDetails && !loading">
    <div class="flex flex-col">
      <div class="mt-4 mb-16 ml-4">
        <div class="flex flex-col lg:flex-row text-grey-800" >
          <div class="lg:w-1/3 lg:px-4" >
            <div
              id="div-details-titleIntro"
            >
              <label class="body-default-bold" id="sim-publication-title-Intro-label">Title Intro</label>
              <p class="body-default-regular" id="sim-publication-title-Intro-value" [innerHTML]="SIMPublicationDetails?.titleIntro"></p>
            </div>
            <div
              id="div-details-title-main"
            >
              <label class="body-default-bold" id="sim-publication-title-main-label">Title Main</label>
              <p class="body-default-regular" id="sim-publication-title-main-value" [innerHTML]="SIMPublicationDetails?.titleMain"></p>
            </div>
            <div
              id="div-details-title-part"
            >
              <label class="body-default-bold" id="sim-publication-title-part-label">Title Part</label>
              <p class="body-default-regular " id="sim-publication-title-part-value" [innerHTML]="SIMPublicationDetails?.titlePart"></p>
            </div>
            <div
              id="div-details-title-full"
            >
              <label class="body-default-bold" id="sim-publication-title-full-label">Title Full</label>
              <p class="body-default-regular" id="sim-publication-title-full-value" [innerHTML]="SIMPublicationDetails?.titleFull"></p>
            </div>
            <div
              id="div-details-SDO"
            >
              <label class="body-default-bold" id="sim-publication-sdo-label">SDO</label>
              <p class="body-default-regular" id="sim-publication-sdo-value">
                  {{SIMPublicationDetails?.sdo}}
              </p>
            </div>
            <div
              id="div-details-language"
            >
              <label class="body-default-bold" id="sim-publication-language-label">Language</label>
              <p class="body-default-regular" id="sim-publication-language-value">
                  {{SIMPublicationDetails?.language}}
              </p>
            </div>
          </div>
          <div class="lg:w-1/3 lg:px-4">
            <div id="div-details-release-version">
              <label class="body-default-bold" id="sim-publication-release-version-label">Release Version</label>
              <p class="body-default-regular " id="sim-publication-release-version-value">
                  {{SIMPublicationDetails?.releaseVersion}}
              </p>
            </div>
            <div
              id="div-details-urn"
            >
              <label class="body-default-bold" id="sim-publication-urn-label">URN</label>
              <p class="body-default-regular" id="sim-publication-urn-value">
                  {{SIMPublicationDetails?.urn}}

              </p>
            </div>
            <div
              id="div-details-isbn"
            >
              <label class="body-default-bold" id="sim-publication-isbn-label">ISBN</label>
              <p class="body-default-regular" id="sim-publication-isbn-value">
                  {{SIMPublicationDetails?.isbn}}
              </p>
            </div>
            <div
              id="div-details-originator"
            >
              <label class="body-default-bold" id="sim-publication-originator-label">Originator</label>
              <p class="body-default-regular" id="sim-publication-originator-value">
                  {{SIMPublicationDetails?.originator}}
              </p>
            </div>
            <div
              id="div-details-publication-type"
            >
              <label class="body-default-bold" id="sim-publication-type-label">Publication Type</label>
              <p class="body-default-regular" id="sim-publication-type-value">
                  {{SIMPublicationDetails?.publicationType}}
              </p>
            </div>
            <div
              id="div-details-doc-number"
            >
              <label class="body-default-bold" id="sim-publication-doc-number-label">Doc Number</label>
              <p class="body-default-regular" id="sim-publication-doc-number-value">
                  {{SIMPublicationDetails?.docNumber}}
              </p>
            </div>
            <div
              id="div-details-part-number"
            >
              <label class="body-default-bold" id="sim-publication-details-part-number-label">Part Number</label>
              <p class="body-default-regular" id="sim-publication-details-part-number-value">
                  {{SIMPublicationDetails?.partNumber}}
              </p>
            </div>
          </div>
          <div class="lg:w-1/3 lg:px-4">
            <div id="div-ProjectType">
              <label class="body-default-bold" id="sim-publication-project-type-label">Edition</label>
              <p class="body-default-regular " id="sim-publication-project-type-value">
                  {{SIMPublicationDetails?.edition}}
              </p>
            </div>
            <div
              id="div-PublicationStatus"
            >
              <label class="body-default-bold" id="sim-publication-status-label">Version</label>
              <p class="body-default-regular">
                  {{SIMPublicationDetails?.version}}
              </p>
            </div>
            <div
              id="div-details-page-count"
            >
              <label class="body-default-bold" id="sim-publication-page-count-label">Page Count</label>
              <p class="body-default-regular" id="sim-publication-page-count-value">
                  {{SIMPublicationDetails?.pageCount}}
              </p>
            </div>
            <div
              id="div-details-content-language"
            >
              <label class="body-default-bold" id="sim-publication-details-content-language-label">Content Language</label>
              <p class="body-default-regular" id="sim-publication-details-content-language-value">
                  {{SIMPublicationDetails?.contentLanguage}}
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="loading || !SIMPublicationDetails">
    <div class="flex justify-center items-center min-h-[40vh]">
      <div *ngIf="loading">
        <app-loading-indicator [size]="32"></app-loading-indicator>
      </div>
    </div>
  </ng-container>
</div>


